import * as React from "react"
import type { SVGProps } from "react"
const SvgOrderedList = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M3.75 22.14A.73.73 0 0 1 3 21.4a.73.73 0 0 1 .75-.75H5.5v-.75h-.75a.73.73 0 0 1-.75-.75.73.73 0 0 1 .75-.75h.75v-.75H3.75A.73.73 0 0 1 3 16.9a.73.73 0 0 1 .75-.75H6a.97.97 0 0 1 1 1v1q0 .43-.29.72a1 1 0 0 1-.71.28.97.97 0 0 1 1 1v1q0 .43-.29.72a1 1 0 0 1-.71.28zm0-7A.73.73 0 0 1 3 14.4v-2q0-.42.29-.71A1 1 0 0 1 4 11.4h1.5v-.75H3.75A.73.73 0 0 1 3 9.9a.73.73 0 0 1 .75-.75H6a.97.97 0 0 1 1 1v1.75q0 .43-.29.72a1 1 0 0 1-.71.28H4.5v.75h1.75a.73.73 0 0 1 .75.75.73.73 0 0 1-.75.75zm1.5-7a.73.73 0 0 1-.75-.75V3.64h-.75A.73.73 0 0 1 3 2.9a.73.73 0 0 1 .75-.75h1.5A.73.73 0 0 1 6 2.9v4.5a.73.73 0 0 1-.75.75m4.75 11a1 1 0 0 1-.71-.28 1 1 0 0 1-.29-.72q0-.42.29-.71a1 1 0 0 1 .71-.29h10q.42 0 .71.29.3.3.29.71c-.01.41-.1.52-.29.72a1 1 0 0 1-.71.28zm0-6a1 1 0 0 1-.71-.28 1 1 0 0 1-.29-.72q0-.42.29-.71a1 1 0 0 1 .71-.29h10q.42 0 .71.29.3.3.29.71c-.01.41-.1.52-.29.72a1 1 0 0 1-.71.28zm0-6a1 1 0 0 1-.71-.28A1 1 0 0 1 9 6.14q0-.42.29-.71a1 1 0 0 1 .71-.29h10q.42 0 .71.29.3.3.29.71c-.01.41-.1.52-.29.72a1 1 0 0 1-.71.28z" />
  </svg>
)
export default SvgOrderedList
